// React
import { Navigate, Outlet } from "react-router-dom";

// Libraries
import { useTranslation } from "react-i18next";

// Components
import PortalLoading from "Common/Components/PortalLoading";

// Auth
import { useMBSAuth } from "Auth/MBS/MBSAuthContext";

const MBSUnauthenticatedRoute = () => {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading } = useMBSAuth();

  if (isLoading) {
    return <PortalLoading message={t("common.loading")} />;
  }

  if (isAuthenticated) {
    return <Navigate to="/mbs/home" replace />;
  }

  return <Outlet />;
};

export default MBSUnauthenticatedRoute;
